export const SLOT_PAGE_ASSET_NAME = 'Games info article ID';
export const GAMES_INFO_POPUP_ID = 'GAMES_INFO_POPUP_ID';
export const INFO_GAME_LIST_FROM_STORAGE = 'infoGameList';
export const INFO_GAME_FEED_FROM_STORAGE = 'infoGameFeed';
